<script lang="ts" setup>

import type { Props } from './types'

import AppSlider from '@/components/AppSlider/index.vue'
import AppChatRecommendationCard from '@/components/App/ChatV2/RecommendationCard/index.vue'

import './_index.scss'

defineProps<Props>()

</script>

<script lang="ts">
export default {
  name: 'AppChatRecommendationsV2'
}
</script>

<template>
  <div class="app-chat__recommendations">
    <AppSlider
      :id="`${screen}-app-chat-recommendations-carousel`"
      lateral-paddings="hidden"
      :slider-scroll="250"
      show-buttons
      navigation-button-size="sm"
      :padding-right="true">
      <AppChatRecommendationCard
        v-for="listing in listings"
        :key="`app-chat-recomendation-card-${listing.code}`"
        :project="listing"
        :screen />
    </AppSlider>
  </div>
</template>
